import _defineProperty from "@babel/runtime/helpers/defineProperty";
const ANY_EVENT_IDENTIFIER = '*';
export class BackwardCompatibleAssistantPlatformSdk {
  constructor(emitter) {
    this.emitter = emitter;
    _defineProperty(this, "listeners", new Map());
    _defineProperty(this, "activeListenersChange", void 0);
  }
  emitEvent(appDefId, event, payload) {
    this.emitter.emitEvent({
      appDefinitionId: appDefId,
      name: event,
      payload,
      conversationId: undefined
    });
  }
  onEvent(appDefId, event, listener) {
    var _this$activeListeners;
    const wrappedListener = sideEffect => {
      if (sideEffect.appDefinitionId === appDefId && sideEffect.name === event) {
        listener(sideEffect.payload);
      }
    };
    this.emitter.addEventListener(wrappedListener);
    const mapper = this.getListenerMap(appDefId, event);
    mapper.set(listener, wrappedListener);
    (_this$activeListeners = this.activeListenersChange) == null || _this$activeListeners.call(this, appDefId, [event]);
  }
  offEvent(appDefId, event, listener) {
    const mapper = this.getListenerMap(appDefId, event);
    const wrappedListener = mapper.get(listener);
    if (wrappedListener) {
      this.emitter.removeEventListener(wrappedListener);
      mapper.delete(listener);
    }
  }
  onAnyEvent(appDefId, listener) {
    var _this$activeListeners2;
    const wrappedListener = sideEffect => {
      if (sideEffect.appDefinitionId === appDefId) {
        listener(sideEffect.name, sideEffect.payload);
      }
    };
    this.emitter.addEventListener(wrappedListener);
    const mapper = this.getListenerMap(appDefId, ANY_EVENT_IDENTIFIER);
    mapper.set(listener, wrappedListener);
    (_this$activeListeners2 = this.activeListenersChange) == null || _this$activeListeners2.call(this, appDefId, [ANY_EVENT_IDENTIFIER]);
  }
  offAnyEvent(appDefId, listener) {
    const mapper = this.getListenerMap(appDefId, ANY_EVENT_IDENTIFIER);
    const wrappedListener = mapper.get(listener);
    if (wrappedListener) {
      this.emitter.removeEventListener(wrappedListener);
      mapper.delete(listener);
    }
  }
  getActiveListeners() {
    const activeListeners = {};
    this.listeners.forEach((eventListeners, appDefId) => {
      activeListeners[appDefId] = Array.from(eventListeners.keys());
    });
    return activeListeners;
  }
  setActiveListenersObserver(listener) {
    this.activeListenersChange = listener;
  }
  getListenerMap(appDefId, event) {
    if (!this.listeners.has(appDefId)) {
      this.listeners.set(appDefId, new Map());
    }
    const eventListeners = this.listeners.get(appDefId);
    if (!eventListeners.has(event)) {
      eventListeners.set(event, new Map());
    }
    return eventListeners.get(event);
  }
}
//# sourceMappingURL=BackwardCompatibleAssistantPlatformSdk.js.map